import HeroImageProvider, { useHeroImage } from './hero-image-provider';

export default HeroImageProvider;
export { useHeroImage };
export * from './consts';
export * from './types';
